import React, { ReactElement } from "react";
import "./style.scss";

interface SpinnerProps {
  dark?: boolean;
  small?: boolean;
  large?: boolean;
  customClassName?: string;
}

function Spinner(props: SpinnerProps): ReactElement {
  const {
    dark: isDark, customClassName, large, small
  } = props;

  return (
    <div
      className={`
                Spinner 
                ${customClassName || ""}
                ${isDark ? "Spinner--color-dark" : "Spinner--color-light"}
                ${large ? "Spinner--size-large" : ""}
                ${small ? "Spinner--size-small" : ""}
            `}
    >
      <div className="Spinner__blade" />
      <div className="Spinner__blade" />
      <div className="Spinner__blade" />
      <div className="Spinner__blade" />
      <div className="Spinner__blade" />
      <div className="Spinner__blade" />
      <div className="Spinner__blade" />
      <div className="Spinner__blade" />
    </div>
  );
}

Spinner.defaultProps = {
  customClassName: null,
  dark: null,
  large: null,
  small: null
};

export default Spinner;
